import "./App.css";
import '@fortawesome/fontawesome-free/css/all.min.css'
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect, useState } from "react";

import Sidebar from "./components/SidebarMultinet";
import Navbar from "./components/Navbar";
import { Provider } from "react-redux";
import store from "./redux/store";
import AdminFarm from "./components/Forms/AdminFarms";
import AdminLots from "./components/Forms/AdminLots";
import AdminLines from "./components/Forms/AdminLines";
import AdminPalms from "./components/Forms/AdminPalms";
import AdminProducts from "./components/Forms/AdminProducts";
import AdminUsers from "./components/Forms/AdminUsers";
import Login from "./components/views/login";
import CreateLinesPalmsExcel from "./components/Forms/CreateLinesPalmsExcel";
import UpdateCoordinatesExcel from "./components/Forms/UpdateCoordinatesExcel";
import MenuLines from "./components/Forms/MenuLines";
import Track from "./components/Maps/Track";
import TrackMapBox from "./components/Maps/TrackMapBox";
import ProtectedRoute from "./components/Utils/ProtectedRoute";
import ConsolidatedReport from "./components/Reports/ConsolidatedReport";
import SupervisionReport from "./components/Reports/SupervisionReport";
import SupervisionMetrics from "./components/Reports/SupervisionMetrics";

import DashboardAverage from "./components/DashboarDate/DashboardAverage";
import DashboardHome from "./components/DashboarDate/DashboardHome";
import DashboardProjection from "./components/DashboarDate/DashboardProjection";
import DashBoardProductivity from "./components/DashboarDate/DashBoardProductivity";
import DashboardPerformance from "./components/DashboarDate/DashboardPerformance";
import DashboardFirstApplications from "./components/DashboarDate/DashboardFirstApplications";
import DashboardFirstApplicationsYear from "./components/DashboarDate/DashboardFirstApplicationsYear";
import DashBoardCycles from "./components/DashboarDate/DashBoardCycles";
import ComparativeCycles from "./components/DashboarDate/ComparativeCycles";


import FirstApplicationsWeek from "./components/DashboardWeek/FirstApplication";

import Heatmap from "./components/Maps/HeatMapLeafLef";
import OperatingPerformance from "./components/DashboarDate/OperatingPerformance";
import AdminSection from "./components/Forms/AdminSection";
import PaymentReport from "./components/Reports/PaymentReport";
import ConsumptionReport from "./components/Reports/ConsumptionReport";
import SupervisionQuality from "./components/Reports/SupervisionQuality";
import SupervisionReliability from "./components/Reports/SupervisionReliability";
import LotMapBox from "./components/Maps/LotMapBox";
import MapFarm from "./components/Maps/MapFarm";
import MapFarmPalms from "./components/Maps/MapFarmPalms";
import LinePalmEdition from "./components/Maps/LinePalmEdition";
import LinePalmRename from "./components/Maps/LinePalmRename";
import AccumulationByMonth from "./components/Reports/AccumulationByMonth";
import AccumulationByLot from "./components/Reports/AccumulationByLot";
import LotMapInventory from "./components/Maps/LotMapInventory";
import HealthMovementMap from "./components/Maps/HealthMovementMap";
import HealthTreatmentMap from "./components/Maps/HealthTreatmentMap";
import HealthDetailed from "./components/Reports/HealthDetailed";
import AdminHealthIssues from "./components/Forms/AdminHealthIssues";


import UploadMovements from "./components/Records/UploadMovements";
import UpdateRecord from "./components/Records/UpdateRecord";
import InsertRecord from "./components/Records/InsertRecord";
import UpdateSupervision from "./components/Records/UpdateSupervision";
import AccumulationReport from "./components/Records/AccumulationReport";

///IRRIGATION
import AdminRainFall from "./components/Forms/AdminRainFall";


import { ConfigProvider } from "antd";
import esES from "antd/locale/es_ES";
import DashboardQuantityWeek from "./components/DashboardWeek/DashboardQuantityWeek";
import MapFirstApplication from "./components/Maps/MapFirstApplication";
import HeatMapFirstApplication from "./components/Maps/HeatMapFirstApplication";
import MapFirstApplicationHeatMap from "./components/Maps/MapFirstApplicationHeatMap";
import DuplicateReport from "./components/Reports/DuplicateReport";
import OperatorLotReport from "./components/Reports/OperatorLotReport";



import DashboardYieldHome from "./components/DashboardYield/DashboardYieldHome";
import YieldOperatorLotReport from "./components/Reports/YieldOperatorLotReport";
import YieldDetailedReport from "./components/Reports/YieldDetailedReport";
import DashboardFirstApplicationsMonth from "./components/DashboarDate/DashboardFirstApplicationsMonth";
import RainFallProduction from "./components/DashboarDate/RainFallProduction";
import PhenologicalReport from "./components/Reports/PhenologicalReport";
import DashboardPhenological from "./components/DashboarDate/DashboardPhenological";
import CycleCompliance from "./components/Maps/CycleCompliance";
import PolygonHectareLot from "./components/Maps/PolygonHectareLot";
import OperatingIndicators from "./components/DashboarDate/OperatingIndicators";
import AccumulationByMonthLot from "./components/Reports/AccumulationByMonthLot";
import HealthTrapMap from "./components/Maps/HealthTrapMap";
import PollinationDetailedReport from "./components/Reports/PollinationDetailedReport";
import MapFirstApplicationRange from "./components/Maps/MapFirstApplicationRange";

function App() {
  const [sidebarVisible, setSidebarVisible] = useState("true");
  const is_login = localStorage.getItem("isLogin");
  const [isLogin, setIsLogin] = useState("false");

  function showSideBar() {
    if (sidebarVisible == "true") setSidebarVisible("false");
    else setSidebarVisible("true");
  }

  function verifyLogin() {
    const is_login = localStorage.getItem("isLogin");
    setIsLogin(is_login);
  }


  const hideSidebar = () => {
    // Cierra el menú automáticamente en dispositivos móviles
    if (window.innerWidth < 768) {
      setSidebarVisible(false);
    }
  };


  useEffect(() => {
    const is_login = localStorage.getItem("isLogin");
    console.log(is_login);
    const value = JSON.parse(isLogin);
    setSidebarVisible(is_login);
    setIsLogin(is_login);
    hideSidebar()
  }, []);

  return (
    <ConfigProvider locale={esES}>
    <Provider store={store}>
      <BrowserRouter>
        <div className="d-flex">
          <div className={(is_login == "true")&&(sidebarVisible == "true") ? "w-auto" : "d-none"}>
            <Sidebar    hideSidebar={hideSidebar}  />
          </div>
          <div className="col overflow-auto">
            <div className={(is_login == "true") ? "w-auto" : "d-none"}>
              <Navbar changeToogle={showSideBar} />
            </div>

            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/dashboard-average" element={<ProtectedRoute><DashboardAverage /></ProtectedRoute>} />
              <Route path="/first-applications" element={<ProtectedRoute><DashboardFirstApplications /></ProtectedRoute>} />
              <Route path="/first-applications-month" element={<ProtectedRoute><DashboardFirstApplicationsMonth /></ProtectedRoute>} />
              <Route path="/yearly-comparison" element={<ProtectedRoute><DashboardFirstApplicationsYear /></ProtectedRoute>} />
              <Route path="/operating-performance" element={<ProtectedRoute><OperatingPerformance /></ProtectedRoute>} />
              <Route path="/operating-indicators" element={<ProtectedRoute><OperatingIndicators /></ProtectedRoute>} />
              <Route path="/projection" element={<ProtectedRoute><DashboardProjection /></ProtectedRoute>} />
              <Route path="/productivity" element={<ProtectedRoute><DashBoardProductivity /></ProtectedRoute>} />
              <Route path="/performance" element={<ProtectedRoute><DashboardPerformance /></ProtectedRoute>} />
              <Route path="/" element={<ProtectedRoute><DashboardHome /></ProtectedRoute>} />
              <Route path="/cycles" element={<ProtectedRoute><DashBoardCycles /></ProtectedRoute>} />
              <Route path="/comparative-cycles" element={<ProtectedRoute><ComparativeCycles /></ProtectedRoute>} />
              <Route path="/phenological-dashboard" element={<ProtectedRoute><DashboardPhenological /></ProtectedRoute>} />


              
              {/*COSECHA*/} 

              <Route path="/yield" element={<ProtectedRoute><DashboardYieldHome /></ProtectedRoute>} />
              <Route path="/yield-operator-lot-report" element={<ProtectedRoute><YieldOperatorLotReport /></ProtectedRoute>} />
              <Route path="/yield-detailed-report" element={<ProtectedRoute><YieldDetailedReport /></ProtectedRoute>} />



              {/*DASHBOARD WEEK*/}              
              <Route path="/first-applications-week" element={<ProtectedRoute><FirstApplicationsWeek /></ProtectedRoute>} />
              <Route path="/dashboard-quantity-week" element={<ProtectedRoute><DashboardQuantityWeek /></ProtectedRoute>} />

              <Route path="/admin-farms" element={<ProtectedRoute><AdminFarm /></ProtectedRoute>} />
              <Route path="/admin-section" element={<ProtectedRoute><AdminSection /></ProtectedRoute>} />
              <Route path="/admin-lots" element={<ProtectedRoute><AdminLots /></ProtectedRoute>} />
              <Route path="/menu-lines" element={<ProtectedRoute><MenuLines /></ProtectedRoute>} />
              <Route path="/admin-lines" element={<ProtectedRoute><AdminLines /></ProtectedRoute>} />
              <Route path="/admin-palms" element={<ProtectedRoute><AdminPalms /></ProtectedRoute>} />
              <Route path="/admin-users" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />      
              <Route path="/admin-products" element={<ProtectedRoute><AdminProducts /></ProtectedRoute>} />   
              <Route path="/upload-movements" element={<ProtectedRoute><UploadMovements /></ProtectedRoute>} />   


              <Route path="/update-coordinates-excel" element={<ProtectedRoute><UpdateCoordinatesExcel /></ProtectedRoute>}/>

              <Route path="/create-lines-palms-excel" element={<ProtectedRoute><CreateLinesPalmsExcel /></ProtectedRoute>} />

              
              <Route path="/report-operator-lot" element={<ProtectedRoute><OperatorLotReport /></ProtectedRoute>} />     
              <Route path="/report-consumption" element={<ProtectedRoute><ConsumptionReport /></ProtectedRoute>} />     
              <Route path="/report-payment" element={<ProtectedRoute><PaymentReport /></ProtectedRoute>} />     
              <Route path="/report-movements" element={<ProtectedRoute><ConsolidatedReport /></ProtectedRoute>} />     
              <Route path="/pollination-detailed-report" element={<ProtectedRoute><PollinationDetailedReport /></ProtectedRoute>} />     
              <Route path="/report-duplicate" element={<ProtectedRoute><DuplicateReport /></ProtectedRoute>} />  
              <Route path="/supervision-report" element={<ProtectedRoute><SupervisionReport /></ProtectedRoute>} />    
              <Route path="/supervision-metrics" element={<ProtectedRoute><SupervisionMetrics /></ProtectedRoute>} /> 
              <Route path="/supervision-quality" element={<ProtectedRoute><SupervisionQuality /></ProtectedRoute>} />    
              <Route path="/supervision-reliability" element={<ProtectedRoute><SupervisionReliability /></ProtectedRoute>} />    
              <Route path="/accumulation-by-month" element={<ProtectedRoute><AccumulationByMonth /></ProtectedRoute>} />     
              <Route path="/accumulation-by-month-lot" element={<ProtectedRoute><AccumulationByMonthLot /></ProtectedRoute>} />   
              <Route path="/accumulation-by-lot" element={<ProtectedRoute><AccumulationByLot /></ProtectedRoute>} />   
              <Route path="/phenological-report" element={<ProtectedRoute><PhenologicalReport /></ProtectedRoute>} />    

              
              <Route path="/cycle-compliance" element={<ProtectedRoute><CycleCompliance /></ProtectedRoute>} />
              <Route path="/fruit-inventory" element={<ProtectedRoute><LotMapInventory /></ProtectedRoute>} />
              <Route path="/map-farm" element={<ProtectedRoute><MapFarm /></ProtectedRoute>} />
              <Route path="/map-farm-palms" element={<ProtectedRoute><MapFarmPalms /></ProtectedRoute>} />
              <Route path="/lot-map/:lotId" element={<ProtectedRoute><LotMapBox /></ProtectedRoute>} />
              <Route path="/lot-map-edition/:lotId" element={<ProtectedRoute><LinePalmEdition /></ProtectedRoute>} />
              <Route path="/lot-map-rename/:lotId" element={<ProtectedRoute><LinePalmRename /></ProtectedRoute>} />
              <Route path="/track" element={<ProtectedRoute><Track /></ProtectedRoute>} />
              <Route path="/track-mapbox" element={<ProtectedRoute><TrackMapBox /></ProtectedRoute>} />
              <Route path="/polygon-hectare-lot" element={<ProtectedRoute><PolygonHectareLot /></ProtectedRoute>} />
              <Route path="/non-productive-plants" element={<ProtectedRoute><Heatmap /></ProtectedRoute>} />
              <Route path="/map-first-application" element={<ProtectedRoute><MapFirstApplication /></ProtectedRoute>} />
              <Route path="/map-first-application-range" element={<ProtectedRoute><MapFirstApplicationRange /></ProtectedRoute>} />
              <Route path="/heat-map-first-application" element={<ProtectedRoute><MapFirstApplicationHeatMap /></ProtectedRoute>} />

              {/* SANIDAD */}
              <Route path="/admin-health-issues" element={<ProtectedRoute><AdminHealthIssues /></ProtectedRoute>} /> 
              <Route path="/health-detailed" element={<ProtectedRoute><HealthDetailed /></ProtectedRoute>} />    
              <Route path="/health-movements-map" element={<ProtectedRoute><HealthMovementMap /></ProtectedRoute>} />  
              <Route path="/health-treatment-map" element={<ProtectedRoute><HealthTreatmentMap /></ProtectedRoute>} />  
              <Route path="/health-trap-map" element={<ProtectedRoute><HealthTrapMap /></ProtectedRoute>} />
                 
              <Route path="/update-record" element={<ProtectedRoute><UpdateRecord /></ProtectedRoute>} /> 
              <Route path="/insert-record" element={<ProtectedRoute><InsertRecord /></ProtectedRoute>} /> 
              <Route path="/update-supervision" element={<ProtectedRoute><UpdateSupervision /></ProtectedRoute>} />  
              <Route path="/report-accumulation" element={<ProtectedRoute><AccumulationReport /></ProtectedRoute>} />   

              
              {/* RIEGO */}
              <Route path="/insert-rainfall" element={<ProtectedRoute><AdminRainFall /></ProtectedRoute>} /> 
              <Route path="/rainfall-production" element={<ProtectedRoute><RainFallProduction /></ProtectedRoute>} /> 


            </Routes>
          </div>
        </div>
      </BrowserRouter>
    </Provider>
    </ConfigProvider>
  );
}

export default App;
